//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./competitor.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// struct Competitor
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Competitor.Mutable`. */
export class Competitor extends $._FrozenBase {}

function initCompetitor(target, initializer) {
  target.id = initializer.id ?? "";
  target.name = initializer.name ?? "";
  target.websiteUrl = initializer.websiteUrl ?? "";
  target.description = initializer.description ?? "";
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
  target.autoSuggested = initializer.autoSuggested ?? false;
}

// -----------------------------------------------------------------------------
// struct CompetitorSuggestion
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CompetitorSuggestion.Mutable`. */
export class CompetitorSuggestion extends $._FrozenBase {}

function initCompetitorSuggestion(target, initializer) {
  target.competitor = Competitor.create(initializer.competitor ?? Competitor.DEFAULT);
  target.reasoning = initializer.reasoning ?? "";
}

// -----------------------------------------------------------------------------
// struct CompetitorSource
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CompetitorSource.Mutable`. */
export class CompetitorSource extends $._FrozenBase {}

function initCompetitorSource(target, initializer) {
  target.title = initializer.title ?? "";
  target.url = initializer.url ?? "";
}

// -----------------------------------------------------------------------------
// struct DetectCompetitorsResult
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `DetectCompetitorsResult.Mutable`. */
export class DetectCompetitorsResult extends $._FrozenBase {}

function initDetectCompetitorsResult(target, initializer) {
  target.suggestions = $._toFrozenArray(
    initializer.suggestions || [],
    CompetitorSuggestion.create,
  );
  target.sources = $._toFrozenArray(
    initializer.sources || [],
    CompetitorSource.create,
  );
}

// -----------------------------------------------------------------------------
// enum PropertyType
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class PropertyType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum SourceType
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class SourceType extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct CompetitorProperty
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CompetitorProperty.Mutable`. */
export class CompetitorProperty extends $._FrozenBase {}

function initCompetitorProperty(target, initializer) {
  target.id = initializer.id ?? "";
  target.value = initializer.value ?? "";
  target.propertyType = PropertyType.create(initializer.propertyType ?? PropertyType.UNKNOWN);
  target.sourceType = SourceType.create(initializer.sourceType ?? SourceType.UNKNOWN);
  target.speakerName = initializer.speakerName ?? "";
  target.meetingId = initializer.meetingId ?? "";
  target.capturedAt = initializer.capturedAt ?? $.Timestamp.UNIX_EPOCH;
  target.quote = initializer.quote ?? "";
  target.confidence = initializer.confidence ?? 0;
  target.isCurrent = initializer.isCurrent ?? false;
  target.meetingType = initializer.meetingType ?? "";
}

// -----------------------------------------------------------------------------
// struct CompetitorIntel
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CompetitorIntel.Mutable`. */
export class CompetitorIntel extends $._FrozenBase {}

function initCompetitorIntel(target, initializer) {
  target.competitorId = initializer.competitorId ?? "";
  target.properties = $._toFrozenArray(
    initializer.properties || [],
    CompetitorProperty.create,
  );
  target.lastUpdated = initializer.lastUpdated ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct CompetitorIntelExtractionResult
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CompetitorIntelExtractionResult.Mutable`. */
export class CompetitorIntelExtractionResult extends $._FrozenBase {}

function initCompetitorIntelExtractionResult(target, initializer) {
  target.competitorIntel = $._toFrozenArray(
    initializer.competitorIntel || [],
    CompetitorIntel.create,
  );
  target.newCompetitorMentions = $._toFrozenArray(
    initializer.newCompetitorMentions || []);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "competitor.skir",
  [
    {
      kind: "struct",
      ctor: Competitor,
      initFn: initCompetitor,
      name: "Competitor",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "website_url",
          property: "websiteUrl",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description",
          property: "description",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "auto_suggested",
          property: "autoSuggested",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CompetitorSuggestion,
      initFn: initCompetitorSuggestion,
      name: "CompetitorSuggestion",
      fields: [
        {
          name: "competitor",
          property: "competitor",
          number: 0,
          type: {
            kind: "record",
            ctor: Competitor,
          },
          mutableGetter: "mutableCompetitor",
        },
        {
          name: "reasoning",
          property: "reasoning",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CompetitorSource,
      initFn: initCompetitorSource,
      name: "CompetitorSource",
      fields: [
        {
          name: "title",
          property: "title",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "url",
          property: "url",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: DetectCompetitorsResult,
      initFn: initDetectCompetitorsResult,
      name: "DetectCompetitorsResult",
      fields: [
        {
          name: "suggestions",
          property: "suggestions",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CompetitorSuggestion,
            },
          },
          mutableGetter: "mutableSuggestions",
        },
        {
          name: "sources",
          property: "sources",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CompetitorSource,
            },
          },
          mutableGetter: "mutableSources",
        },
      ],
    },
    {
      kind: "enum",
      ctor: PropertyType,
      name: "PropertyType",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "PRICING",
          number: 1,
        },
        {
          name: "FEATURE",
          number: 2,
        },
        {
          name: "WEAKNESS",
          number: 3,
        },
        {
          name: "STRENGTH",
          number: 4,
        },
        {
          name: "OBJECTION",
          number: 5,
        },
        {
          name: "OBJECTION_HANDLER",
          number: 6,
        },
        {
          name: "USE_CASE",
          number: 7,
        },
        {
          name: "INTEGRATION",
          number: 8,
        },
        {
          name: "SUPPORT",
          number: 9,
        },
        {
          name: "TERMS",
          number: 10,
        },
      ],
    },
    {
      kind: "enum",
      ctor: SourceType,
      name: "SourceType",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "INTERNAL",
          number: 1,
        },
        {
          name: "EXTERNAL",
          number: 2,
        },
        {
          name: "WRITTEN",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: CompetitorProperty,
      initFn: initCompetitorProperty,
      name: "CompetitorProperty",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "value",
          property: "value",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "property_type",
          property: "propertyType",
          number: 2,
          type: {
            kind: "record",
            ctor: PropertyType,
          },
        },
        {
          name: "source_type",
          property: "sourceType",
          number: 3,
          type: {
            kind: "record",
            ctor: SourceType,
          },
        },
        {
          name: "speaker_name",
          property: "speakerName",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_id",
          property: "meetingId",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "captured_at",
          property: "capturedAt",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "quote",
          property: "quote",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "confidence",
          property: "confidence",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "float64",
          },
        },
        {
          name: "is_current",
          property: "isCurrent",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "meeting_type",
          property: "meetingType",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CompetitorIntel,
      initFn: initCompetitorIntel,
      name: "CompetitorIntel",
      fields: [
        {
          name: "competitor_id",
          property: "competitorId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "properties",
          property: "properties",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CompetitorProperty,
            },
          },
          mutableGetter: "mutableProperties",
        },
        {
          name: "last_updated",
          property: "lastUpdated",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CompetitorIntelExtractionResult,
      initFn: initCompetitorIntelExtractionResult,
      name: "CompetitorIntelExtractionResult",
      fields: [
        {
          name: "competitor_intel",
          property: "competitorIntel",
          number: 0,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CompetitorIntel,
            },
          },
          mutableGetter: "mutableCompetitorIntel",
        },
        {
          name: "new_competitor_mentions",
          property: "newCompetitorMentions",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableNewCompetitorMentions",
        },
      ],
    },
  ]
);

// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const OUR_PRODUCT_ID = /*@__PURE__*/ $.primitiveSerializer("string").fromJson("__OUR_PRODUCT__");
